import {
  useInfiniteQueryUserLibraryFavorites,
  useKeyUserLibraryFavorites,
  useKeyUserLibraryMyList,
  useQueryUserLibraryFavorites,
} from '@ifit/gateway-wolf-athenaeum-service';
import getNextPageParam from '../get-next-page';
import { useInfiniteQueryOptions, useRowQueryOptions } from '../query-options';
import { useInvalidateOnCallJavaScript } from '../native-bridge-refresh';
import { useInfiniteQueryDataMemo } from '../query-memo';
import { useFeatureFlags } from '../../../helpers/good-cop-helper';

const featureFlag = 'featureflag://flag?key=challenge-store&type=bool';

const useFavoritesInfiniteParams = v2Enabled => ({
  ...useInfiniteQueryOptions(),
  ...(v2Enabled && { excludeChallenges: true }),
});

const useFavoritesRowParams = v2Enabled => ({
  ...useRowQueryOptions(),
  ...(v2Enabled && { excludeChallenges: true }),
});

export const useFavoritesInfiniteQuery = () => {
  const featureFlags = useFeatureFlags([featureFlag]);
  const v2Enabled = featureFlags[featureFlag]
    ? (featureFlags[featureFlag] as boolean)
    : false;
  const opts = useFavoritesInfiniteParams(v2Enabled);

  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryFavorites);
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryMyList);
  return useInfiniteQueryDataMemo(
    useInfiniteQueryUserLibraryFavorites(
      { ...opts },
      {
        getNextPageParam,
      },
    ),
  );
};

export const useFavoritesRowQuery = () => {
  const featureFlags = useFeatureFlags([featureFlag]);
  const v2Enabled = featureFlags[featureFlag]
    ? (featureFlags[featureFlag] as boolean)
    : false;
  const opts = useFavoritesRowParams(v2Enabled);

  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryFavorites);
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryMyList);
  return useQueryUserLibraryFavorites(
    { ...opts },
    {
      getNextPageParam,
    },
  );
};
